import { NessBadgeListView } from '@modules/Ness/App/ProductBadge/components/index.ts';
import { convertToNessBadgeProps } from '@modules/Ness/App/ProductBadge/index.ts';
import $dataStr from 'fxdom/es/dataStr.js';
import { compact, go, html, last, sel, strMap } from 'fxjs/es';
import { GoodsTypeS } from '../../../../../../GoodsType/S/Function/module/GoodsTypeS.js';
import { MpShopProductTmplS } from '../../../../../../MpShop/Product/S/Tmpl/module/MpShopProductTmplS.js';
import { NessOutboundTmplS } from '../../../../../../Ness/Outbound/S/Tmpl/module/NessOutboundTmplS.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopStudioPreDiscountProductS } from '../../../../../Studio/PreDiscountProduct/S/Function/module/MShopStudioPreDiscountProductS.js';
import { MShopUtilConstantS } from '../../../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { MShopAppAdultTmplS } from '../../../../Adult/S/Tmpl/module/MShopAppAdultTmplS.js';
import { MShopAppProductItemS } from '../Function/module/MShopAppProductItemS.js';
import { MShopUtilS } from '../../../../../Util/S/Function/module/MShopUtilS.js';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { CUSTOM_IMAGE_FOLDER_NAME, PRODUCT_BADGE_TYPE, shippingPriceIcon } from '../Constant/item.js';
import { makeProductBadge, makeProductBottomBadge } from './badge.js';
import { returnIf } from '../../../../../Util/S/Function/util.js';
import { makeComingSoonHtmlInProductThumbnail } from './coming_soon.js';
import { makeProductPriceHtml } from './price.js';
import {
  isStoreProductCustom,
  isStoreProductCustomLevelAsset,
  isStoreProductCustomLevelUser,
} from '../../../../../../Creator/Product/S/fs.js';

export const makeBpName = (name, title) => {
  if (!name) return '';
  return name + (title ? ` - ${title}` : '');
};

export const item =
  (sub_class = ['v1'], cus_class = '', data_src, is_mobile = false) =>
  (product) => {
    const {
      id,
      need_adult_check,
      thumbnails,
      name: _name = '',
      rank,
      is_custom_hide,
      ordered_at,
      _: {
        stores_delivery_companies,
        spo: { _: { spo_item_stocks = [] } = {} } = {},
        selected_option_group: { title } = {},
        stores_product: {
          custom_level,
          goods_type_id,
          sell_start_at,
          sell_end_at,
          public_at,
          quantity,
          is_quantity_public,
          order_count,
          id: stores_product_id,
          is_force_out_of_stock,
          _: {
            stores_products_token_gates = [],
            stores_products_like = {},
            store: { domain_name = '', name: store_name = '', logo_img } = {},
          } = {},
        } = {},
        base_product,
        base_product: { thumbnail_ratio, base_product_color_face_url, name: base_product_name } = {},
        pre_discount_product: { pre_discount_price } = {},
      } = {},
    } = product || { _: {} };

    const component = `app-product-item`;

    const origin_price = creatorPriceOfProduct(product);
    const pre_discount_rate = pre_discount_price
      ? MShopStudioPreDiscountProductS.calcDiscountedRateByPercent(pre_discount_price, origin_price)
      : null;

    const is_custom_asset = isStoreProductCustomLevelAsset(custom_level);

    const name = UtilS.trim(_name);
    const bp_name = makeBpName(base_product_name, title) || '';

    const badge = MShopAppProductItemS.setBadge(
      {
        goods_type_id,
        spo_item_stocks,
        sell_start_at,
        sell_end_at,
        public_at,
        quantity,
        order_count,
        ordered_at,
        is_quantity_public,
        is_sptg: !!stores_products_token_gates.length,
        rank: UtilS.isNessApp() ? rank : null,
        is_custom: isStoreProductCustom(custom_level),
        pre_discount_rate,
      },
      false,
    );

    /** @type {TNessBadgeListViewProps | undefined} */
    let nessBadgeProps;
    if (UtilS.isNessApp()) {
      nessBadgeProps = convertToNessBadgeProps({
        goods_type_id,
        quantity,
        order_count,
        is_quantity_public,
        sell_start_at,
        sell_end_at,
        pre_discount_rate,
        public_at,
        is_custom: isStoreProductCustom(custom_level),
        rank: null,
        spo_item_stocks,
        is_force_out_of_stock: !!is_force_out_of_stock,
        limitedMeta: product.limitedMeta,
        lowStockMeta: product.lowStockMeta,
      });
    }

    const product_post_msg = {
      screen: {
        type: 'util',
        title: T('mshop::상품상세'),
        uri: `/${T.lang}/${domain_name}/products/${id}`,
      },
    };
    const store_post_msg = {
      screen: {
        type: 'util',
        title: store_name,
        titleImage: logo_img,
        uri: `/${T.lang}/${domain_name}`,
      },
    };
    const cate_item_name = sel('name' + G._en)(base_product?._?.cate_list);
    const cate_list_id = sel('id')(base_product?._?.cate_list);

    const texts = {
      review_score: ET('product::review::score'),
      review_count:
        UtilS.isNessApp() || UtilS.isMarppleShopApp()
          ? // plural 이라 warning 뜨는데 무시해도 됨 ..
            ET('ness::review::count', { count: parseInt(product.review_count), lng: 'en' })
          : ET('product::review::count'),
    };

    const has_review = !isNaN(Number(product.review_count)) && product.review_count != 0;

    const isSaleEnded = sell_end_at && new Date(sell_end_at) < new Date();

    // TODO: @coconut
    /** @type {ProductStockDto|undefined} */
    const productStock = product.stock;
    const isSoldOut = isSaleEnded || is_force_out_of_stock || productStock?.isOutOfStock;

    const img_alt = go(void 0, () => {
      const _name = name || base_product_name;
      if (UtilS.isMarppleShopApp() && T.lang == 'kr') {
        return `${store_name} ${cate_item_name}, ${_name} 굿즈, 굿즈 판매, 굿즈샵`;
      } else {
        return `${store_name} ${cate_item_name}, ${_name}`;
      }
    });
    const makeThumbnailHtml = () => {
      return need_adult_check
        ? html`<span class="mp-product-img-bg-wrap" style="background-color: #f6f6f6">
            ${MShopAppAdultTmplS.adultItem()}
          </span>`
        : MpShopProductTmplS.thumbnail(
            { thumbnail_ratio, thumbnails, base_product_color_face_url },
            {
              width: 600,
              data_src,
              img_alt,
            },
          );
    };
    const shipping_price = stores_delivery_companies?.[0]?.shipping_price;
    return html`
      <div
        class="app-product-item ${strMap(
          (sc) => `app-product-item--${sc} `,
          compact(sub_class),
        )} ${cus_class}"
        data-is_sold_out="${isSoldOut}"
        data-is_asset="${is_custom_asset}"
        ${is_custom_asset ? `data-cate_list_id=${cate_list_id}` : ''}
        ${is_custom_asset && product?.image_folders?.length
          ? `data-${CUSTOM_IMAGE_FOLDER_NAME}="${last(product?.image_folders ?? [])?.name}"`
          : ``}
        ${is_custom_hide ? 'style="display:none;"' : ''}
      >
        <div class="app-product-item__top-info">
          <a href="${product_post_msg.screen.uri}" data-post-message="${$dataStr(product_post_msg)}">
            <div
              class="app-product-item__img ${badge?.type == PRODUCT_BADGE_TYPE.sold_out
                ? `app-product-item__img--soldout`
                : ''}"
            >
              ${makeThumbnailHtml()}
            </div>
            ${nessBadgeProps
              ? new NessBadgeListView({
                  ...nessBadgeProps,
                  debugInfo: {
                    productId: product.id,
                    displayName: product.name,
                  },
                }).toHtmlSSR()
              : makeProductBadge(badge, component)}

            <!-- only NESS, Coming Soon -->
            ${UtilS.isNessApp() ? makeComingSoonHtmlInProductThumbnail(sell_start_at) : ''}
          </a>

          ${MShopUtilS.returnIf(
            !need_adult_check && !UtilS.isNessApp() && !UtilS.isMarppleShopApp(),
            html`
              <button
                class="app-product-item__like"
                data-stores_product_id="${stores_product_id}"
                data-already_like="${!!stores_products_like?.id}"
              >
                ${MShopCoreTmplS.heartIcon({
                  is_on: !!stores_products_like?.id,
                  klass: `app-product-item__heart`,
                  type: 'solid',
                })}
              </button>
            `,
          )}
        </div>
        <div class="app-product-item__bottom-info">
          ${MShopUtilS.returnIf(
            !isStoreProductCustomLevelUser(custom_level) &&
              !need_adult_check &&
              (UtilS.isNessApp() || UtilS.isMarppleShopApp()),
            html`
              <button
                class="app-product-item__like"
                data-stores_product_id="${stores_product_id}"
                data-already_like="${!!stores_products_like?.id}"
              >
                ${NessOutboundTmplS.nessHeartIcon()}
              </button>
            `,
          )}
          ${MShopUtilS.returnIf(
            rank,
            `
              <a
                href="${store_post_msg.screen.uri}"
                data-post-message="${$dataStr(store_post_msg)}"
                class='app-product-item__rank'
              >
                <span>${rank}</span>
              </a>
            `,
          )}
          <a
            href="${store_post_msg.screen.uri}"
            data-post-message="${$dataStr(store_post_msg)}"
            class="app-product-item__store-name"
          >
            ${store_name}
          </a>
          <a href="${product_post_msg.screen.uri}" data-post-message="${$dataStr(product_post_msg)}">
            <div class="app-product-item__p-name">
              ${GoodsTypeS.isMps(goods_type_id)
                ? (!need_adult_check && name) || bp_name || '&nbsp;'
                : name || '&nbsp;'}
            </div>
            <div class="app-product-item__category-name">${cate_item_name}</div>
            ${makeProductPriceHtml(product)}
          </a>
          ${shipping_price
            ? html`<div class="app-product-item__shipping-price">
                ${shippingPriceIcon()}${UtilS.commify(shipping_price)}원
              </div>`
            : ''}
          <div
            class="app-product-item__review-info ${returnIf(
              !has_review,
              `app-product-item__review-info--hidden`,
            )}"
          >
            <span class="app-product-item__review-score">
              <span class="app-product-item__review-title">${texts.review_score}</span>
              <span class="app-product-item__review-number ${MShopUtilConstantS.UNICA_KLASS}"
                >${product.review_score || 0}</span
              >
            </span>
            <span class="app-product-item__review-count">
              <span class="app-product-item__review-title">${texts.review_count}</span>
              <span class="app-product-item__review-number ${MShopUtilConstantS.UNICA_KLASS}">
                ${UtilS.commaThousands(product.review_count || 0)}
              </span>
            </span>
          </div>
          ${makeProductBottomBadge(badge)}
        </div>
      </div>
    `;
  };
